import { ButtonAsA } from 'components/Button/ButtonAsA';
import type { SiteSeparationRuleType } from './RuleEditor.types';

type UsedAttributeDescriptionProps = {
  selectedType: SiteSeparationRuleType;
  onClose: () => void;
  goToAuthenticationVendors?: () => void;
};

export const UsedAttributeDescription = ({
  selectedType,
  onClose,
  goToAuthenticationVendors,
}: UsedAttributeDescriptionProps) => {
  if (selectedType === 'regexHostname') {
    return (
      <p>
        Site name will be generated from a hostname value. This value is found
        during network discovery.
      </p>
    );
  }

  if (selectedType !== 'slug') {
    return null;
  }

  return (
    <p>
      Site name will be generated from Slug value defined in{' '}
      <ButtonAsA
        onClick={() => {
          onClose();
          goToAuthenticationVendors?.();
        }}
      >
        Vendor API
      </ButtonAsA>{' '}
      list.
    </p>
  );
};
